import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import AVReactPlayer from './AVReactPlayer';
import { RingLoader } from 'react-spinners';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const Container = styled.div`
  /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledButton = styled.button`
  background-color: #48BB78;
  &:hover {
    background-color: #38A169;
  }
  color: white;
  font-size: 1.5em;  // Измените размер шрифта для увеличения кнопки
  padding: 10px 20px;  // Увеличьте отступы для увеличения кнопки
  border-radius: 5px;
  font-weight: bold;
`;

const StyledButtonDelete = styled.button`
  background-color: #f44336;
  &:hover {
    background-color: #e53935;
  }
  color: white;
  font-size: 1.5em;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; // Use the full height of the viewport
  width: 100%; // Use the full width
`;

const StyledMessage = styled.div`
  text-align: center; 
  color: #48BB78; 
  font-size: 28px;
  margin-bottom: 10px; 
`;

const CropContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1000px;
  margin: 0 auto;
`;

const AVFraming = (props) => {
    const {
        titleFraming,
        titleTrim,
        titleDownload,
        titleDelete,
        titleReady,
        titleCancel,
        titleCurrentFile,
        titleTrimAnotherVideo,
    } = props.attributes;

    const {
        videoWidthExt,
        videoHeightExt,
    } = props;

    /* console.log(props.videoWidthExt); */

    const [currentTime, setCurrentTime] = useState(0);
    const [showPlayer, setShowPlayer] = useState(true);
    const [showImage, setShowImage] = useState(false);
    const [imageSrc, setImageSrc] = useState(null);
    const [imageSize, setImageSize] = useState('1000px');
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [crop, setCrop] = useState({
        unit: 'px', // Can be 'px' or '%'
        x: 25,
        y: 25,
        width: 50,
        height: 50,
        aspect: 1
    });
    const [originalImageWidth, setOriginalImageWidth] = useState(null);
    const [originalImageHeight, setOriginalImageHeight] = useState(null);
    const [ratio, setRatio] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [cropStartX, setCropStartX] = useState(null);
    const [cropEndX, setCropEndX] = useState(null);
    const [cropStartY, setCropStartY] = useState(null);
    const [cropEndY, setCropEndY] = useState(null);
    const imgRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);

    const handleImageLoaded = (image) => {
        imgRef.current = image;
    };

    const getImageWidth = () => {
        if (imgRef.current) {
            return imgRef.current.getBoundingClientRect().width;
        }
        return null;
    };


    useEffect(() => {
        if (imageSrc) {
            const image = new Image();
            image.src = imageSrc;
            image.onload = () => {
                setOriginalImageWidth(image.width);
                setOriginalImageHeight(image.height);
                /* console.log('123 ' + getImageWidth()); */
                setRatio(image.width / getImageWidth());
                /* setRatio(image.width /); */
            };
        }
    }, [imageSrc]);

    // Обработчик изменения выделения
    const handleCropChange = (newCrop) => {
        setCrop(newCrop);
    };

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            let newSize = '1000px';

            if (screenWidth < 400) {
                newSize = '320px';
            } else if (screenWidth < 768) {
                newSize = '600px';
            } else if (screenWidth < 1024) {
                newSize = '800px';
            }

            setImageSize(newSize);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleCurrentTimeChange = (time) => {
        setCurrentTime(time);
        console.log(time);
    };

    const handleCropComplete = (crop, pixelCrop) => {
        console.log("Here", crop.x * ratio);
        console.log("Here", crop.y * ratio);
        console.log("Here", (crop.x + crop.width) * ratio);
        console.log("Here", (crop.y + crop.height) * ratio);
        console.log('Pixel Crop:', pixelCrop);

        const startX = Math.round(crop.x * ratio);
        const startY = Math.round(crop.y * ratio);
        const endX = Math.round((crop.x + crop.width) * ratio);
        const endY = Math.round((crop.y + crop.height) * ratio);

        setCropStartX(startX);
        setCropStartY(startY);
        setCropEndX(endX);
        setCropEndY(endY);
    };

    const handleFraming = () => {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const requestData = {
            fileid: props.fileId,
            currentTime: currentTime,
        };

        setShowPlayer(false);
        setIsLoading(true);

        const timestamp = Date.now();

        fetch(`/api/getImage?timestamp=${timestamp}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
            },
            body: JSON.stringify(requestData),
        })
            .then(response => response.json())
            .then(data => {
                const imageUrl = data.url;
                console.log('Image URL:', imageUrl);
                console.log('Data:', data.width);
                console.log('Data:', data.height);

                // Сохраняем оригинальные размеры изображения в состояние
                setOriginalImageWidth(data.width);
                setOriginalImageHeight(data.height);

                setIsLoading(false);
                setShowImage(true);
                setImageSrc(imageUrl);
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };


    const handleTrim = async (e) => {
        e.preventDefault();

        setIsLoading(true);
        setShowImage(false);
        const requestBody = {
            ratio: ratio, // передаем значение ratio
            cropStartX: cropStartX, // передаем координаты начала выделения
            cropStartY: cropStartY, // передаем координаты начала выделения
            cropEndX: cropEndX, // передаем координаты конца выделения
            cropEndY: cropEndY, // передаем координаты конца выделения
            fileid: props.fileId,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(`/api/framingVideo?timestamp=${timestamp}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowPlayer(true);
        props.setShowUploader(true);
    }

    const handleCancel = () => {
        setShowPlayer(true);
        setShowImage(false);
    }

    function getFileName(url) {
        return url.substring(url.lastIndexOf('/') + 1);
    }

    const reloadPage = () => {
        location.reload()
    }

    return (
        <Container>
            {showPlayer && (
                <div>

                    {props.videoUrl && <AVReactPlayer onCurrentTimeChange={handleCurrentTimeChange} videoUrl={props.videoUrl} />}
                    <div className="px-4 py-2">
                        <div>{titleCurrentFile}: {props.fileName}</div>
                        <ButtonContainer>
                            <StyledButton onClick={handleFraming}>{titleFraming}</StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {showImage && (<div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <CropContainer>
                        <ReactCrop
                            ruleOfThirds
                            crop={crop}  // Привязка состояния выделения к ReactCrop
                            onChange={handleCropChange}  // Обработка изменения выделения
                            onComplete={handleCropComplete}  // Обработка завершения выделения
                            onImageLoaded={handleImageLoaded}
                        >
                            <img ref={imgRef} src={imageSrc} />
                        </ReactCrop>
                    </CropContainer>
                </div>
                <div className="px-4 py-2">
                    <ButtonContainer>
                        <StyledButton onClick={handleTrim}>{titleTrim}</StyledButton>
                        <div className='pl-2'>
                            <StyledButtonDelete onClick={handleCancel}>{titleCancel}</StyledButtonDelete>
                        </div>
                    </ButtonContainer>
                </div>
            </div>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3" role="alert">
                            {errorMessage}
                        </div>

                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>{titleTrimAnotherVideo}</StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader color={'#123abc'} loading={isLoading} size={150} />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    <div className="px-4 py-2">
                        <AVReactPlayer onCurrentTimeChange={handleCurrentTimeChange} videoUrl={downloadUrl} />
                    </div>
                    <ButtonContainer>
                        <a href={downloadUrl} download={getFileName(downloadUrl)} onClick={handleDownload}>
                            <StyledButton>{titleDownload}</StyledButton>
                        </a>
                        <a className='pl-2' onClick={handleDownload}>
                            <StyledButtonDelete>{titleDelete}</StyledButtonDelete>
                        </a>
                    </ButtonContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>{titleTrimAnotherVideo}</StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default AVFraming;
